@if (totalCostDetails()) {
  <p class="font-style m-b-16">Exchange Rate {{ totalCostDetails().shopExchangeRateToUsd }}</p>
  <div class="m-b-12">
    <p class="font-style">Material</p>
    <mc-table [data]="materialCostTotal()" [columns]="materialCost" fit="small" sortdisabled="true">
      @for (row of materialCostTotal(); track row; let i = $index) {
        <div slot="{{ row.id }}_repairCode" class="font-style">
          {{ row.repairCode }}
        </div>
        <div slot="{{ row.id }}_isoCurrencyCodeUSD" class="font-style">
          {{ row.isoCurrencyCodeUSD }}
        </div>
        <div slot="{{ row.id }}_isoCurrencyCodeLocal" class="font-style">
          {{ row.isoCurrencyCodeLocal }}
        </div>
      }
    </mc-table>
  </div>
  <div class="m-b-12">
    <p class="font-style">Labor</p>
    <p class="m-b-4">Preparation Time - {{ preparationHours }} hrs</p>
    <p class="m-b-4">Total Hours Including Preparation Time - {{ totalHours }} hrs</p>
    <mc-table [data]="laborCostTotal()" [columns]="laborCost" fit="small" sortdisabled="true">
      @for (row of laborCostTotal(); track row; let i = $index) {
        @if (row.id === 'labor-cost-ex-tax') {
          <div slot="{{ row.id }}_category" class="font-style">
            {{ row.category }}
          </div>
          <div slot="{{ row.id }}_laborCostUSD" class="font-style">
            {{ row.laborCostUSD }}
          </div>
          <div slot="{{ row.id }}_laborCostLocal" class="font-style">
            {{ row.laborCostLocal }}
          </div>
        }
      }
    </mc-table>
  </div>
  @if (hasParts()) {
    <div class="m-b-12">
      <p class="font-style">Parts</p>
      <mc-table [data]="partCostTotal()" [columns]="partCost" fit="small" sortdisabled="true">
        @for (row of partCostTotal(); track row; let i = $index) {
          <div slot="{{ row.id }}_partNumber" class="font-style">
            {{ row.partNumber }}
          </div>
          <div slot="{{ row.id }}_partCostUSD" class="font-style">
            {{ row.partCostUSD }}
          </div>
          <div slot="{{ row.id }}_partCostLocal" class="font-style">
            {{ row.partCostLocal }}
          </div>
        }
      </mc-table>
    </div>
  }
  <div class="m-b-12">
    <p class="font-style">Tax</p>
    <mc-table [data]="taxTotal()" [columns]="tax" fit="small" sortdisabled="true">
      @for (row of taxTotal(); track row; let i = $index) {
        <div slot="{{ row.id }}_taxCategory" class="font-style">
          {{ row.taxCategory }}
        </div>
        <div slot="{{ row.id }}_totalTaxUSD" class="font-style">
          {{ row.totalTaxUSD }}
        </div>
        <div slot="{{ row.id }}_totalTaxLocal" class="font-style">
          {{ row.totalTaxLocal }}
        </div>
      }
    </mc-table>
  </div>
  <div class="m-b-12">
    <p class="font-style">Total</p>
    <mc-table [data]="totalCost()" [columns]="total" fit="small" sortdisabled="true"> </mc-table>
  </div>
}
